<template>
  <transition
    name="fade">
    <div
      v-show="showing"
      class="FilterMenu"
      :class="{ showing }"
      @click.self="$emit('close')">

      <transition
        name="slide-up">
        <div
          v-if="showing"
          class="FilterMenu_Menu"
          @click.stop>

          <header
            class="FilterMenu_Header">
            <transition
              name="slide-left">
              <BaseButton
                v-if="!activeFilterType"
                class="Header_btn"
                theme="ghost"
                @click="handleNavClick">
                X
              </BaseButton>
            </transition>

            <transition
              name="slide-right">
              <BaseButton
                v-if="activeFilterType"
                class="Header_btn"
                theme="ghost"
                @click="handleNavClick">
                ❮
              </BaseButton>
            </transition>

            <h3
              class="Header_title">
              Filter
            </h3>

            <!-- <transition
              name="fade">
              <BaseButton
                v-if="activeFilterType"
                class="Header_apply"
                theme="ghost"
                @click="handleApplyChanges">
                Apply
              </BaseButton>
            </transition> -->
          </header>

          <div
            class="FilterMenu_Body">
            <transition
              name="filter-menu-slide-left">
              <div
                v-if="!activeFilterType"
                key="TFM-filter-types"
                class="FilterTypes">
                <h6
                  class="FilterTypes_title">
                  Filters
                </h6>
                <div
                  class="FilterTypes_scroll">
                  <div
                    class="FilterType"
                    v-for="filterType in filters"
                    :key="filterType.key"
                    @click="handleFilterTypeClick(filterType)">
                    {{ filterType.label }}
                  </div>
                </div>
              </div>
            </transition>

            <transition
              name="filter-menu-slide-right">
              <FilterGroup
                class="FilterMenu_FilterGroup"
                v-if="activeFilterType"
                key="TFM-active-filter-type"
                :group-key="activeFilterType.key"
                :label="activeFilterType.label"
                :filters="activeFilterType.filters"
                :show-count="activeFilterType.showCount"
                :search-bar="activeFilterType.searchBar"
                :search-placeholder="activeFilterType.searchPlaceholder"
                :value="value"
                @input="handleFilterInput"
              />
            </transition>
          </div>
        </div>
      </transition>

    </div>
  </transition>
</template>

<script>
import FilterGroup from '@/components/FilterGroup.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'FilterMenu',

  components: {
    FilterGroup,
    BaseButton,
  },

  data() {
    return {
      activeFilterType: null,
    };
  },

  props: {
    value:   { type: Array,   required: true },
    showing: { type: Boolean, default: false },
    filters: { type: Array,   default: () => [] },
  },

  methods: {
    handleFilterInput(groupKey, filter) {
      this.$emit('filter-input', groupKey, filter);
    },

    handleNavClick() {
      if (this.activeFilterType) {
        this.activeFilterType = null;
        return;
      }
      this.$emit('close');
    },

    handleFilterTypeClick(filterType) {
      this.activeFilterType = this.filters.find((f) => f.key === filterType.key);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

$filter-menu-header-height: 56px;

.FilterMenu {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($black, .5);
}

.FilterMenu_Menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30%;
  min-height: 330px;
  background-color: $white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 0 24px rgba($black, .2);
}

.FilterMenu_Header {
  position: relative;
  height: $filter-menu-header-height;
  justify-content: space-between;
  align-items: center;
  border-bottom: $border;
}

.Header_btn {
  position: absolute;
  top: 8px;
  left: 8px;
}

.Header_title {
  text-align: center;
  line-height: $filter-menu-header-height;
}

.Header_apply {
  position: absolute;
  top: 8px;
  right: 8px;
  color: $dark-blue;
}

.FilterMenu_Body {
  position: relative;
  flex: 1 1 auto;
  overflow: hidden;
}

.FilterTypes {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
}

.FilterTypes_title {
  padding-left: 16px;
  color: $mute;
  line-height: 32px;
  text-transform: uppercase;
  white-space: nowrap;
  border-bottom: $border;
  background-color: #F6F6F6;
}

.FilterTypes_scroll {
  flex: 1 1 auto;
  padding-bottom: 8px;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
}

.FilterType {
  position: relative;
  padding-left: 16px;
  padding-right: 40px;
  line-height: 40px;
  height: 40px;
  border-bottom: $border;
  cursor: pointer;
  &:after {
    content: '>';
    position: absolute;
    top: 0;
    right: 16px;
    bottom: 0;
    margin: auto;
  }
}

.FilterMenu_FilterGroup {
  height: 100%;
  &:not(:last-child) {
    border-bottom: $border;
  }
}

// Slide Left
.filter-menu-slide-left-enter-active,
.filter-menu-slide-left-leave-active {
  transition: all .2s ease 0s;
}
.filter-menu-slide-left-enter,
.filter-menu-slide-left-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-30%);
}

// Slide Right
.filter-menu-slide-right-enter-active,
.filter-menu-slide-right-leave-active {
  transition: all .2s ease 0s;
}
.filter-menu-slide-right-enter,
.filter-menu-slide-right-leave-to {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transform: translateX(30%);
}
</style>
